var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IMAGE_ASSET_PATHS } from '../../../const/alertsConfig';
import getAssetHost from '../../../helpers/getAssetHost';
import { useAlerts } from '../../customHooks';
import { ErrorBodyWrapper, ErrorContentWrapper, ErrorImageWrapper, ErrorTitleWrapper } from './subcomponents';
var ErrorInfoWrapper = function (_a) {
    var _b;
    var errorBody = _a.errorBody, errorTitle = _a.errorTitle;
    var config = useAlerts().appConfig.config;
    var ASSET_HOST = ((_b = config === null || config === void 0 ? void 0 : config.hosts) === null || _b === void 0 ? void 0 : _b.assets) || "".concat(getAssetHost(), "/");
    return (_jsxs(ErrorContentWrapper, __assign({ "data-test": "ErrorContentWrapper" }, { children: [_jsx(ErrorImageWrapper, __assign({ "data-test": "ErrorImageWrapper" }, { children: _jsx("img", { src: "".concat(ASSET_HOST).concat(IMAGE_ASSET_PATHS.ERROR_IMAGE), alt: "Error" }) })), _jsx(ErrorTitleWrapper, __assign({ id: "errorTitle", "data-test": "ErrorTitleWrapper" }, { children: errorTitle })), _jsx(ErrorBodyWrapper, __assign({ id: "errorMicroAlerts", "data-test": "ErrorBodyWrapper" }, { children: errorBody }))] })));
};
export default ErrorInfoWrapper;
